'use client'
import { LayoutModal } from 'design-system/client'
import { usePathname, useRouter } from 'next/navigation'
import { useTranslations } from 'next-intl'
import { type ReactNode, useCallback } from 'react'
import { Routes } from '@/helpers/utils'
import type { Locale } from '@/i18n/types'

type ModalShellProps = {
  children: ReactNode
  locale: Locale
  slug: string
  externalStyles?: Record<string, string | undefined>
  pathToModal: string
  title: string
}

function ModalShell({ children, locale, slug, externalStyles, pathToModal, title }: ModalShellProps) {
  const t = useTranslations('nextjs')
  const router = useRouter()
  const onClose = useCallback(() => {
    router.push(Routes.fundraisingEvents({ locale, slug }, true))
  }, [locale, router, slug])

  // navigating back with router.push with parallel routing does not close the modal
  const pathname = usePathname()

  const isOpen = pathname.includes(pathToModal)

  return (
    <LayoutModal
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      closeText={t('core.close')}
      closeOnClickOutside
      classNames={externalStyles}
    >
      {children}
    </LayoutModal>
  )
}
export default ModalShell
